import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RolesType } from 'src/app/enums/RolesType.enum';
import { Escolaridad } from 'src/app/interfaces/escolaridad';
import { Experiencia } from 'src/app/interfaces/experiencia';
import { Habilidad } from 'src/app/interfaces/habilidad';
import { Idioma } from 'src/app/interfaces/idioma';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { PerfilCandidato } from 'src/app/interfaces/perfil';
import { Ciudad, Estado } from 'src/app/interfaces/ubicaciones';
import { CertificacionService } from 'src/app/services/certificacion/certificacion.service';
import { EscolaridadService } from 'src/app/services/escolaridad/escolaridad.service';
import { ExperienciaService } from 'src/app/services/experiencia/experiencia.service';
import { HabilidadService } from 'src/app/services/habilidad/habilidad.service';
import { IdiomaService } from 'src/app/services/idioma/idioma.service';
import { UbicacionService } from 'src/app/services/ubicacion/ubicacion.service';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { environment } from 'src/environments/environment';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';

@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidate-details.component.html',
  styleUrls: ['./candidate-details.component.scss']
})
export class CandidateDetailsComponent implements OnInit {

  noPagina: number;
  usuario: JwtResponse;
  candidato: PerfilCandidato;
  verArchivos: string;
  estados: Estado[];
  ciudades: Ciudad[];
  estadoInicial: string;
  ciudadInicial: string;
  Habilidades: Habilidad[];

  constructor(private title: Title, private meta: Meta, private activedRoute: ActivatedRoute,
    private router: Router, private modalService: NgbModal, private usuarioService: UsuarioService,
    private expericiaService: ExperienciaService, private escolaridadService: EscolaridadService,
    private habilidadesService: HabilidadService, private idiomasService: IdiomaService,
    private certificacionService: CertificacionService, @Inject(PLATFORM_ID) private platformId: object,
    private ubicacionService: UbicacionService) {
    this.agregarMetaData();
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.candidato = {} as PerfilCandidato;
    this.verArchivos = environment.baseArchivos;
  }

  ngOnInit(): void {
    if(this.usuario && this.usuario.role == RolesType.EMPRESAS){
      const idCandidato = this.activedRoute.snapshot.params.idCandidato;
      if(idCandidato){
        this.obtenerDetallesCandidatoPorId(idCandidato);
      }
    }else{
      this.abrirModalMessage("Alerta", "Usted no tiene permitido acceder a esta página");
      this.router.navigate(['/']);
    }
  }

  private agregarMetaData(): void {
    this.title.setTitle('Detalles del Candidato');
    this.meta.updateTag({name: "description", content: "Detalla la información de un candidato, señalando sus capacidades y talentos del mismo."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "candidato, datos, información, cv, perfil"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Detalles del Candidato"});
    this.meta.updateTag({property: "og:description", content: "Detalla la información de un candidato, señalando sus capacidades y talentos del mismo."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Detalles del Candidato"});
    this.meta.updateTag({name: "twitter:description", content:"Detalla la información de un candidato, señalando sus capacidades y talentos del mismo."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  async obtenerDetallesCandidatoPorId(idCandidato: number){
    try {
      const response = await this.usuarioService.obtenerDetallesCandidatoPorId(idCandidato);
      this.candidato = response.data;
      if(this.candidato){
        this.candidato.avatar = (this.candidato.avatar != environment.candidatoDefault ? this.verArchivos + this.candidato.avatar : this.candidato.avatar);
        this.obtenerExperienciaCandidato(idCandidato);
        this.obtenerCertificacionCandidato(idCandidato);
        this.obtenerEscolaridadCandidato(idCandidato);
        this.obtenerHabilidadesCandidato(idCandidato);
        this.obtenerIdiomasCandidato(idCandidato);
        this.cargarEstados();
        this.cargarCiudades(response.data.idEstado);
      }
    } catch (error) {
      console.error("Error en obtener la información del candidato " + idCandidato, error);
    }
  }

  async cargarEstados() {
    try {
      const response = await this.ubicacionService.obtenerEstados();
      this.estados = response.data;
      if (this.estados) {
        this.estadoInicial = this.estados.find(estado => estado.id === this.candidato.idEstado).nombre;
      }
    } catch (error) {
      console.error("Error al cargar el combo estados", error);
    }
  }

  async cargarCiudades(idEstado: number) {
    try {
      const response = await this.ubicacionService.obtenerCiudadesPorEstado(idEstado);
      this.ciudades = response.data;
      if (this.ciudades) {
        this.ciudadInicial = this.ciudades.find(ciudad => ciudad.claveCiudad === this.candidato.idCiudad).nombre;
      }
    } catch (error) {
      console.error("Error al cargar el combo ciudades.", error);
    }
  }

  async obtenerExperienciaCandidato(idCandidato: number){
    try {
      const response = await this.expericiaService.obtenerExperienciasPorIdCandidato(idCandidato);
      this.candidato.experiencias = response.data;
    } catch (error) {
      console.error("error al obtener la experiencia del candidato", error);
    }
  }

  async obtenerCertificacionCandidato(idCandidato: number){
    try {
      const response = await this.certificacionService.obtenerCertificacionesPorIdCandidato(idCandidato);
      this.candidato.certificaciones = response.data;
    } catch (error) {
      console.error("error al obtener la experiencia del candidato", error);
    }
  }

  async obtenerEscolaridadCandidato(idCandidato: number){
    try {
      const response = await this.escolaridadService.obtenerEscolaridadPorIdCandidato(idCandidato);
      this.candidato.escolaridades = response.data;
    } catch (error) {
      console.error("error al obtener la escolaridad del candidato", error);
    }
  }

  async obtenerHabilidadesCandidato(idCandidato: number){
    try {
      const response = await this.habilidadesService.obtenerHabilidadesPorIdCandidato(idCandidato);
      this.Habilidades = response.data;
    } catch (error) {
      console.error("error al obtener las habilidades del candidato", error);
    }
  }

  async obtenerIdiomasCandidato(idCandidato: number){
    try {
      const response = await this.idiomasService.obtenerIdiomasPorIdCandidato(idCandidato);
      this.candidato.idiomas = response.data;
    } catch (error) {
      console.error("error al obtener los idiomas del candidato", error);
    }
  }

  redirigirUrl(url: string): void{
    const isUrl = /^http[s]?/;
    if(!isUrl.test(url)){
      url = 'https://' + url;
    }

    if (isPlatformBrowser(this.platformId)) {
      window.open(url, '_blank');
    }
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }
}
